import { Accordion, Mobile, TRANSITION_END, Carousel_CoreInit, Form_CoreInit } from './core'
import Header from './modules/header'
import Splash from './modules/splash'
import './plugins/forms'
import './plugins/mini-tabs'
import './plugins/rolling-banner'
import './plugins/event-filters'
import './plugins/featured-images'
import './plugins/read-more'
import './plugins/scroll-to-anchor'
import './plugins/upcoming-sale'

Carousel_CoreInit()

Form_CoreInit([
  {
    classSelector: 'builder-form',
    formOptions: {
      floating_labels: true,
    },
  }
])

$(function() {
  var os = '';
  if (navigator.appVersion.indexOf('Win') != -1) os = 'windows';
  if (navigator.appVersion.indexOf('Mac') != -1) os = 'mac';
  if (navigator.appVersion.indexOf('X11') != -1) os = 'unix';
  if (navigator.appVersion.indexOf('Linux') != -1) os = 'linux';
  $('body').addClass('os--' + os);

  Splash.init()

  $.mlmi = {
    mobile: new Mobile(),
  }

  /* Header */
  Header.init()

  /* Accordions */
  Accordion.init()
  $('.js-accordion--start-open').each(function() {
    var textContent = $(this).find('.accordion__panel-content')
    var outerHeight = textContent.outerHeight()
    $(this).find('.js-accordion__panel').css('max-height', outerHeight + 'px')
  })

  $('.accordion--mini-tabs').each(function() {
    $(this).MiniTabs()
  })

  $('.page-section.js-accordion .js-accordion').each(function() {
    $(this).EmbeddedTabs()
  })

  /* Forms */
  $('.newsletter-form').each(function() {
    $(this).NewsletterForm()
  })

  $('.school-form').each(function() {
    $(this).SchoolForm()
  })

  $('.venue-form').each(function() {
    $(this).VenueForm()
  })

  $('.banner').each(function() {
    $(this).RollingBanner()
  })

  $('.event-filters').each(function() {
    $(this).EventFilters()
  })

  $('.tickets__item__sale-date').each(function() {
    $(this).UpcomingSale()
  })
  $('.js-search').click(function() {
    if (!$(this).hasClass('--search-context')) {
      var container = $(this).closest('.event-filters__search');
      var search_key = container.find('.event-filters__search-field').val()
      if (search_key != '') {
        window.location.href = container.attr('data-url') + '?sk=' + search_key
      }
    }
  })

  $('.splash__images').each(function() {
    $(this).featuredImages()
  })

  $('.show-header__description').each(function() {
    $(this).readMore()
  })

  $('.other-dates__item').each(function() {
    let self = $(this)
    $(this).find('> a').click(function() {
      self.css('--max-height', self.find('.tickets').outerHeight() + 'px');
      self.toggleClass('--open')
      return false;
    })
  })

  /* Scrolll to anchors */
  $('a[href^=#]').each(function() {
    $(this).scrollToAnchor()
  })

  $('a[href*=#]').click(function() {
    if ($(this).attr('href').includes(window.location.host)) {
      var href = $(this).attr('href')
      var href_data = href.split("#");
      if (window.location.href.includes(href_data[0])) {
        var targetTop = $('#' + href_data[1]).offset().top;
        targetTop -= ($.mlmi.mobile.isMobile ? 90 : 120);
        $('html, body').scrollTo(targetTop, 400, 5, 'easeInOutQuart')
        window.location.href = $(this).attr('href');
        $('body').removeClass('--search-open')
        $('body').removeClass('--menu-open')
        return false;
      }
    }
  })
})

$(window).on('load', function() {
  var hash = location.hash;
  if (hash != '' && $(hash).length > 0) {
    var targetTop = $(hash).offset().top;
    targetTop -= ($.mlmi.mobile.isMobile ? 90 : 120);
    $('html, body').scrollTo(targetTop, 400, 5, 'easeInOutQuart')
  }
});
